import {
    defaultCriteriaResource,
    useCriteriaActions,
} from '../../../../resource/resources/artifacts/criteria/criteriaResource';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { OpenModal } from '../../../../../../react-commons/utils/modals/openModal';
import {
    defaultProcessAreaCriteriaAssociationResource,
    useProcessAreaCriteriaAssociationActions,
} from '../../../../resource/resources/artifacts/process_area/processAreaCriteriaAssociationResource';
import { StackedCardsComponent } from '../../../reusable-components/StackedCardsComponent';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import React from 'react';
import { CriteriaEditDialog } from '../../project/reusable-elements/criteria/CriteriaEditDialog';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { CriteriaDirection } from '../../../../resource/enumerations/CriteriaDirection';
import { formatIdentifier } from '../../../../../../react-commons/utils/utilFunctions';

export const StackedCriteriasView = ({isAdmin, processAreaId, versionId, direction, link}: {
    isAdmin: boolean, processAreaId: string | undefined, versionId: string | undefined, direction: CriteriaDirection,
    link: string | undefined
}) => {

    const nestedDialog = useNestedDialogFunction();
    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();

    const criteriaAssociationActions = useProcessAreaCriteriaAssociationActions();
    const criteriaActions = useCriteriaActions();
    const criteriaAssociationsQuery = criteriaAssociationActions.useGetAllResources(processAreaId)
    const criteriasQuery = criteriaActions.useGetAllResources(versionId);

    const deleteCriteriaAssociation = criteriaAssociationActions.useDeleteResource();
    const addCriteriaAssociation = criteriaAssociationActions.useAddResource();
    const addCriteria = criteriaActions.useAddResource();

    const getCriteriaAssociationFilteredByDirection = () => criteriaAssociationsQuery.data?.filter(value => value.direction === direction) ?? []

    const addAssociation = () => OpenModal.SelectionOrCreateModal(
        "Select or Create a Criteria",
        criteriasQuery.data?.filter(criteria =>
            !(getCriteriaAssociationFilteredByDirection().some(association => association.criteria === criteria.objectId)))
            .map(criteria => ({label: criteria.name, value: criteria.objectId})) ?? [],
        true,
        null,
        async (value) => {
            if (value && processAreaId) {
                await addCriteriaAssociation.mutateAsync({
                    resource: {
                        ...defaultProcessAreaCriteriaAssociationResource,
                        criteria: value,
                        direction
                    },
                    parentId: processAreaId
                })
            }
        },
        async (value, multiLineValue) => {
            if (value && processAreaId && versionId) {
                await addCriteria.mutateAsync({
                        resource: {
                            ...defaultCriteriaResource,
                            name: value,
                            description: multiLineValue ?? ""
                        },
                        parentId: versionId
                    },
                    {
                        onSuccess: (result) => {
                            const criteriaObjectId = result?.content?.objectId
                            if (criteriaObjectId) {
                                addCriteriaAssociation.mutateAsync({
                                    resource: {
                                        ...defaultProcessAreaCriteriaAssociationResource,
                                        criteria: criteriaObjectId,
                                        direction
                                    },
                                    parentId: processAreaId
                                })
                            }
                        },
                    }
                )
            }
        },
        undefined,
        "Name",
        true,
        "Description",
        800
    )

    const onDelete = (id: string) => {
        deleteResourceDialogFunction.deleteResource(
            id, null, ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION, deleteCriteriaAssociation
        )
    }

    const onEdit = (id: string) => {
        const association = getCriteriaAssociationFilteredByDirection().find(value => value.id === id)
        if (association) {
            nestedDialog.showNestedDialog(
                <CriteriaEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={association.criteria}
                    versionedInId={versionId ?? ""}
                />
            );
        }
    }

    return (
        <StackedCardsComponent
            title={`${formatIdentifier(direction)} Criteria`}
            data={getCriteriaAssociationFilteredByDirection().map(value => ({
                id: value.id,
                text: criteriasQuery.data?.find(resource => resource.objectId === value.criteria)?.name ?? "",
                description: criteriasQuery.data?.find(resource => resource.objectId === value.criteria)?.description ?? "",
                img: null
            })) ?? []}
            onAdd={isAdmin ? addAssociation : undefined}
            onDelete={isAdmin ? onDelete : undefined}
            onEdit={isAdmin ? onEdit : undefined}
            link={link}
            section={direction === CriteriaDirection.ENTER ? "entry-criteria" : "exit-criteria"}
        />
    );
};